
export const BAKE_SKELETON_CURVE_SYMBOL = Symbol('BakeNodeCurves');
